import { render } from "./ViewerSlideshowPage.vue?vue&type=template&id=326373fc&scoped=true"
import script from "./ViewerSlideshowPage.vue?vue&type=script&lang=js"
export * from "./ViewerSlideshowPage.vue?vue&type=script&lang=js"

import "./ViewerSlideshowPage.vue?vue&type=style&index=0&id=326373fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326373fc"]])

export default __exports__